window.VCA = window.VCA || {};

window.VCA.NCAOfferDataLayer = (function ($) {

    function dataLayerNCAOfferSuccess() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event:'clickevent',
            category:'offer submission',
            action:'new patient offer',
            label:'hospital: first exam 20 off'
        });
    }

    return {
        dataLayerNCAOfferSuccess: dataLayerNCAOfferSuccess
    };

})(jQuery);